if (!customElements.get('recipe-grid-filter')) {
  class RecipeGridFilter extends HTMLElement {
    constructor() {
      super();
      this.currentFilter = 'all';
    }

    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('.recipe-grid-tags__pill'));
      this.items = Array.from(this.querySelectorAll('.recipe-grid-list__item'));

      this.pills.forEach((pill) => {
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          this.setActivePill(pill);
          this.setFilter(pill.dataset.filter);
        });
      });

      const tag = new URLSearchParams(window.location.search).get('tag');
      if (tag) {
        const pill = this.pills.find((button) => button.dataset.filter === tag);
        if (pill) {
          this.setActivePill(pill);
        }
        this.setFilter(tag);
      }
    }

    setActivePill(activePill) {
      this.pills.forEach((pill) => {
        const isActive = pill === activePill;
        pill.classList.toggle('active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    setFilter(filter) {
      this.currentFilter = filter;
      this.filterItems();
    }

    filterItems() {
      let visibleCount = 0;

      this.items.forEach((item) => {
        const tags = item.dataset.tags || '';
        const matches =
          this.currentFilter === 'all' ||
          tags.split(/\s+/).filter(Boolean).includes(this.currentFilter);

        item.classList.toggle('is-hidden', !matches);
        if (matches) {
          visibleCount += 1;
        }
      });

      this.toggleNoResults(visibleCount);
    }

    toggleNoResults(visibleCount) {
      let noResults = this.querySelector('.recipe-grid-list__empty');

      if (visibleCount === 0) {
        if (!noResults) {
          noResults = document.createElement('p');
          noResults.className = 'recipe-grid-list__empty';
          noResults.textContent = this.dataset.emptyText || '';
          this.querySelector('.recipe-grid-body')?.append(noResults);
        }
      } else if (noResults) {
        noResults.remove();
      }
    }
  }

  customElements.define('recipe-grid-filter', RecipeGridFilter);
}
